export default "__VITE_ASSET__Z1uaJTSe3nQTdrWHW_Y$DQ__"